/*
==================================================
CATEGORY CAROUSEL

Функция:
общая оболочка карусели.
Получает подготовленную логику из index.tsx
и передает отдельно в mobile и desktop блоки.

Родитель:
index.tsx

Дочерние элементы:
- category-carousel-mobile
- category-carousel-desktop

Использует:
- category-carousel-config

Примечания:
без собственной бизнес-логики.
==================================================
*/

"use client"

import CategoryCarouselMobile from "./category-carousel-mobile"
import CategoryCarouselDesktop from "./category-carousel-desktop"

type DisplayCategoryItem = {
  id: string
  name: string
  handle?: string | null
  products?: { id: string }[] | null
  children: DisplayCategoryItem[]
}

type CategoryCarouselShellProps = {
  rootItems: DisplayCategoryItem[]
  selectedCategory?: string
  mobileOpen: boolean
  setMobileOpen: React.Dispatch<React.SetStateAction<boolean>>
  mobileCompact: boolean
  expandedCategoryHandle: string | null
  setExpandedCategoryHandle: React.Dispatch<React.SetStateAction<string | null>>
  visibleSubcategories: DisplayCategoryItem[]
  mobileRootRef: React.RefObject<HTMLDivElement | null>
  mobileScrollRef: React.RefObject<HTMLDivElement | null>
  desktopScrollRef: React.RefObject<HTMLDivElement | null>
  onApplyCategory: (handle?: string | null, options?: { closeMobile?: boolean }) => void
  onDesktopSubcategorySelect: (handle?: string | null) => void
  onMobileSubcategorySelect: (handle?: string | null) => void
  onRootCategoryClick: (item: DisplayCategoryItem) => void
  onDesktopRootHover: (item: DisplayCategoryItem) => void
  onDesktopScroll: (direction: "left" | "right") => void
}

export default function CategoryCarouselShell({
  rootItems,
  selectedCategory,
  mobileOpen,
  setMobileOpen,
  mobileCompact,
  expandedCategoryHandle,
  setExpandedCategoryHandle,
  visibleSubcategories,
  mobileRootRef,
  mobileScrollRef,
  desktopScrollRef,
  onApplyCategory,
  onDesktopSubcategorySelect,
  onMobileSubcategorySelect,
  onRootCategoryClick,
  onDesktopRootHover,
  onDesktopScroll,
}: CategoryCarouselShellProps) {
  return (
    <>
      <CategoryCarouselMobile
        rootItems={rootItems}
        selectedCategory={selectedCategory}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        mobileCompact={mobileCompact}
        expandedCategoryHandle={expandedCategoryHandle}
        visibleSubcategories={visibleSubcategories}
        mobileRootRef={mobileRootRef}
        mobileScrollRef={mobileScrollRef}
        onApplyCategory={onApplyCategory}
        onMobileSubcategorySelect={onMobileSubcategorySelect}
        onRootCategoryClick={onRootCategoryClick}
      />

      <CategoryCarouselDesktop
        rootItems={rootItems}
        selectedCategory={selectedCategory}
        expandedCategoryHandle={expandedCategoryHandle}
        setExpandedCategoryHandle={setExpandedCategoryHandle}
        visibleSubcategories={visibleSubcategories}
        desktopScrollRef={desktopScrollRef}
        onApplyCategory={onApplyCategory}
        onDesktopSubcategorySelect={onDesktopSubcategorySelect}
        onRootCategoryClick={onRootCategoryClick}
        onDesktopRootHover={onDesktopRootHover}
        onDesktopScroll={onDesktopScroll}
      />
    </>
  )
}
